export default __webpack_public_path__ + "static/starberry-logo-03c612f1d54e5a3e4484bb853bdf5cdd.png";